import React, { useState } from 'react';
import { Paper, Typography } from '@mui/material';
import {
  useTable,
  type SortingState,
} from '@tanstack/react-table';
import { features } from '../common/tableFeatures';
import { DataTable } from '../common/DataTable';
import {
  useGetDeploymentsQuery,
  type DeploymentKind,
  type DeploymentSummary,
} from '@store/api/deploymentsApi';
import { deploymentSummaryColumns } from './deploymentColumns';

const EMPTY: DeploymentSummary[] = [];

/** The latest Deployments of one kind, each linking to its progress page. */
const RecentDeployments: React.FC<{ kind: DeploymentKind; title?: string }> = ({
  kind,
  title = 'Recent Deployments',
}) => {
  const [sorting, setSorting] = useState<SortingState>([]);
  const { data, isLoading } = useGetDeploymentsQuery({ kind, limit: 10 });

  const table = useTable({
    features,
    // RTK Query keeps `data` referentially stable; the fallback must be too, or
    // every render hands TanStack a new array.
    data: data ?? EMPTY,
    columns: deploymentSummaryColumns,
    state: { sorting },
    onSortingChange: setSorting,
    getRowId: (row) => row.id,
  });

  return (
    <>
      <Typography variant="h6" component="h2" sx={{ mt: 4, mb: 1 }}>
        {title}
      </Typography>
      <Paper sx={{ width: '100%' }}>
        <DataTable
          table={table}
          ariaLabel={title}
          isLoading={isLoading}
          emptyMessage="No deployments yet."
          minWidth={750}
        />
      </Paper>
    </>
  );
};

export default RecentDeployments;
